/* eslint-disable no-undef */
import $ from 'jquery';
import { RouteParams } from 'universal-router';
import { Page } from '../Page';
import { tns } from 'tiny-slider';


export class HomePage extends Page {
    public static render(params: RouteParams): void {
        HomePage._initTinySlider();
    }

    private static _initTinySlider() {
        if ($('.view-slider-home .view-unformatted__row').length > 0) {
            tns({
                "container": ".view-slider-home .view-unformatted__row",
                "items": 1,
                "center": true,
                "mouseDrag": true,
                "slideBy": "page",
                "swipeAngle": false,
                "speed": 400,
                "autoplay": true,
                "autoplayTimeout": 5000,
                "controls": false,
                "nav": true,
                "navPosition": 'bottom',
            });
        }
    }
}
